import { useCallback } from 'react'
import { Penalty } from '~/shared/api'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { filters } from './filters'
import { GridRow } from './types'

export const ListPenalties = () => {
  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, filters = [], sort) => {
      let builder = Penalty.limit(pageSize)

      filters?.forEach(({ key, value }) => {
        builder = builder.where(key, value)
      })

      sort
        ? (builder = builder.orderBy(sort))
        : (builder = builder.orderBy('-createdAt'))

      const response = await builder.get(page)
      const data = response.getData()
      const rows = data.map((penalty: Penalty) => ({
        ...penalty.getAttributes(),
        id: penalty?.getApiId() as UniqueId,
        carBrandModel: penalty.getBrandModel(),
        penaltyTime: penalty.getPenaltyDatetime(),
      }))

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='penalties-list'
      fetchRows={fetchRows}
      columns={columns}
      filters={filters}
      smallTitle='Штрафы'
    />
  )
}
